export const fontSizeList = [
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "14", value: "14" },
    { label: "16", value: "16" },
    { label: "18", value: "18" },
    { label: "20", value: "20" },
    { label: "22", value: "22" },
    { label: "24", value: "24" },
    { label: "26", value: "26" },
    { label: "28", value: "28" },
    { label: "30", value: "30" },
    { label: "32", value: "32" },
    { label: "34", value: "34" },
    { label: "36", value: "36" },
    { label: "38", value: "38" },
    { label: "40", value: "40" },
    { label: "42", value: "42" },
    { label: "44", value: "44" },
    { label: "46", value: "46" },
    { label: "48", value: "48" },
    { label: "50", value: "50" },
    { label: "52", value: "52" },
    { label: "60", value: "60" },
    { label: "72", value: "72" },
    { label: "96", value: "96" },
];

export const fontList = [
    { label: "Arial", value: "Arial" },
    { label: "Calibri", value: "Calibri" },
    { label: "Garamond", value: "Garamond" },
    { label: "Georgia", value: "Georgia" },
    { label: "Helvetica", value: "Helvetica" },
    { label: "Inter", value: "Inter" },
    { label: "Italic", value: "Italic" },
    { label: "Lato", value: "Lato" },
    { label: "Manrope", value: "Manrope" },
    { label: "Montserrat", value: "Montserrat" },
    { label: "Open Sans", value: "Open Sans" },
    { label: "Oswald", value: "Oswald" },
    { label: "Playfair Display", value: "Playfair Display" },
    { label: "Poppins", value: "Poppins" },
    { label: "Roboto", value: "Roboto" },
    { label: "Sans Serif", value: "sans-serif" },
    { label: "Satoshi", value: "Satoshi" },
    { label: "Times New Roman", value: "Times New Roman" },
    { label: "Urbanist", value: "Urbanist" },
    { label: "Verdana", value: "Verdana" },
];

export const colorList = [
    { name: "Black", code: "#000000" },
    { name: "White", code: "#ffffff" },
    { name: "Red", code: "#ff0000" },
    { name: "Orange", code: "#ffa500" },
    { name: "Yellow", code: "#ffff00" },
    { name: "Deep Sky Blue", code: "#4075b9" },
    { name: "Blue", code: "#002b61" },
    { name: "Deep Blue", code: "#181c45" },
    { name: "Purple", code: "#800080" },
    { name: "Hot Pink", code: "#ff69b4" },
    { name: "Green", code: "#00be62" },
    { name: "Deep Green", code: "#008000" },
    { name: "Teal", code: "#008080" },
    { name: "Gold", code: "#ffd700" },
    { name: "Brown", code: "#8b4513" },
    { name: "Dark Gray", code: "#545454" },
    { name: "Grey", code: "#959595" },
    { name: "Light Grey", code: "#e3e3e4" },
]
